import { render, staticRenderFns } from "./ContractRenewalStatusBanner.vue?vue&type=template&id=4479d050&"
import script from "./ContractRenewalStatusBanner.vue?vue&type=script&lang=ts&"
export * from "./ContractRenewalStatusBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports